import { render, staticRenderFns } from "./AdminCompanies.vue?vue&type=template&id=ad7e8174&scoped=true&"
import script from "./AdminCompanies.vue?vue&type=script&lang=js&"
export * from "./AdminCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7e8174",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad7e8174')) {
      api.createRecord('ad7e8174', component.options)
    } else {
      api.reload('ad7e8174', component.options)
    }
    module.hot.accept("./AdminCompanies.vue?vue&type=template&id=ad7e8174&scoped=true&", function () {
      api.rerender('ad7e8174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminCompanies.vue"
export default component.exports